


























































import { Vue, Component } from 'vue-property-decorator'
import Listing from '@/components/admin/polls/Listing.vue'
const shortid = require("shortid")
const _ = require("lodash");

@Component({
    components: { Listing }
})
export default class PollControl extends Vue {
    newPoll = {
        name: "",
        allowMultiple: false,
        maxAnswers: 1,
        choices: <any>[]
    }

    newPollChoice () {
        this.newPoll.choices.push({
            name: "",
        });
    }
    removePollChoice (index: number) {
        this.newPoll.choices.splice(index, 1);
    }

    savePoll (): void {
        if(!this.newPoll.name) return;
        if(!this.newPoll.allowMultiple) this.newPoll.maxAnswers = 1;
        if(this.newPoll.maxAnswers > this.newPoll.choices.length) this.newPoll.maxAnswers = this.newPoll.choices.length;

        this.$store.dispatch("API_CALL", { method: "post", url: `/events/${this.event._id}/polls`,
        data: this.newPoll, headers: { ['x-access-token']: localStorage.adminToken} }).then((res) => {
            this.socket.emit("new_poll", res.data.poll);
            this.newPoll.choices = [];
            this.newPoll.name = "";
            this.newPoll.maxAnswers = 1;
        }).catch(err => {
            console.error(err);
        })
    }

    deletePoll(id:string): void {
        this.$store.dispatch("API_CALL", { method: "delete", url: `/events/${this.event._id}/polls`,
        data: { pollId: id }, headers: { ['x-access-token']: localStorage.adminToken }}).then((res) => {
            this.socket.emit("delete_poll", id);
        }).catch(err => {
            console.error(err);     
        })
    }

    cuePoll(id:string): void {
        const hasActive = this.polls.find((poll:any) => poll.status === 'active');
        if(hasActive && hasActive.id !== id) this.socket.emit("cue_poll", hasActive.id);

        setTimeout(() => {
            this.socket.emit("cue_poll", id);
        }, 500)
    }

    get event(): any {
        return this.$store.state.event;
    }
    get polls(): Array<any> {
        const polls = this.event.polls.filter((poll:any) => !poll.isDeleted).reverse();

        polls.forEach((poll:any) => {
            let cutVotes = 0
            if(poll.cutUsers && poll.cutUsers.length) cutVotes = poll.cutUsers.reduce((acc: number, cur: any) => { return acc + parseInt(cur.cutVotes) }, 0)
            poll.cutVotes = cutVotes
        })
        return polls
    }
    get socket():any {
        return this.$store.state.socket;        
    }
}
